import React from 'react';

const Page14Socials = () => {
  return (
    <>
      <div className="thank-you-container">
        <h2 className="thank-you-heading">Submission Complete!</h2>
        <p className="thank-you-text">Your feedback has been successfully submitted. We value your input and will use it to improve our services.</p>
        
        <div className="social-links">
          <a 
            href="https://www.linkedin.com/company/cloudphysician/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link"
          >
            <img 
              src="/linkedIN.png" 
              alt="LinkedIn" 
              className="social-icon"
            />
          </a>
          <a 
            href="https://www.cloudphysician.net/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link"
          >
            <img 
              src="/logo3.png" 
              alt="Cloudphysician" 
              className="company-icon"
            />
          </a>
        </div>
        
        <p className="farewell-text">Feel free to connect with us on social media or visit our website for more information.</p>
      </div>
    </>
  );
};

export default Page14Socials; 